module.exports = __webpack_public_path__ + "img/i-6.1c7bea83.svg";